import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { postActivityType } from "./ServiceActivityType";
import { useTranslation } from "react-i18next";
export default function AddActivityType() {

  const navigate = useNavigate();

  const [data, setData] = useState({
    cropsOrLivestock: "",
    activityType: "",
    activityTypeArab: "",
    activityTypeAng: "",
  });
 const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState({});

  // Gestion des champs
  const onInputchange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  // Enregistrement
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      await postActivityType(data);

      toast.success(t("typeActivite.saveSuccess"), {
        position: "bottom-right",
        autoClose: 2000,
      });

      setData({
        cropsOrLivestock: "",
        activityType: "",
        activityTypeArab: "",
        activityTypeAng: "",
      });

      setErrorMessage({});

      navigate("/listActivitytype");

    } catch (error) {
      //console.log("ERREUR COMPLETE");
      //console.log(error.response);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errors
      ) {

        const errorArray = error.response.data.errors;

        // Construction du toast
        const formattedErrors = errorArray.map((err, index) => {

          const msg =
            err.indexOf(":") > -1
              ? err.split(":")[1]
              : err;

          return (
            <li key={index} className="list-group-item">
              {msg}
            </li>
          );
        });

        toast.error(
          <div style={{ width: "18rem" }}>
            <div className="card-header text-danger">
              <h5 className="card-title">
                {t("common.validationErrors")}
              </h5>
            </div>

            <div className="card-body">
              <ul className="list-group list-group-flush">
                {formattedErrors}
              </ul>
            </div>
          </div>,
          {
            position: "bottom-right",
            autoClose: 4000,
          }
        );

        const errorObject = {};

        errorArray.forEach((err) => {

          if (err.indexOf(":") > -1) {

            const [field, message] = err.split(":");

            errorObject[field.trim()] = message.trim();
          }
        });

        setErrorMessage(errorObject);

      } else {

        toast.error("Erreur lors de l'enregistrement");

        console.error(error);
      }
    }
  };

  return (
    <div
      className="div-width"
      style={{ marginTop: "6rem" }}
    >
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-5">

          <li className="breadcrumb-item">
            <i className="fa-solid fa-house"></i>

            <Link
              className="mx-2"
              to="/"
            >
               {t("menu.home")}
            </Link>
          </li>

          <li className="breadcrumb-item">
            <Link
              className="mx-2"
              to="/ListActivitytype"
            >
              {t("typeActivite.titre")}
            </Link>
          </li>

          <li className="breadcrumb-item active">
           {t("typeActivite.new")}
          </li>

        </ol>
      </nav>

      <div className="table-container">

        <div className="title div-responsive d-flex text-white justify-content-center align-items-center">
          <i className="fa-solid fa-folder-plus fa-2xl"></i>
        </div>

        <div className="border shadow rounded-2 p-3">

          <h4 className="ajst-titre mb-4">
          {t("typeActivite.new")}
          </h4>

          <form onSubmit={onSubmit}>
            <div className="row justify-content-center">
              <div className="col-md-6">
                {/* Crops Or Livestock */}
                <div className="mb-3">
                  <label className="form-label required-label">
                    {t("monProfile.activityType")}
                  </label>
                  <select
                    className="form-select"
                    name="cropsOrLivestock"
                    value={data.cropsOrLivestock}
                    onChange={onInputchange}
                  >
                    <option value="">{t("common.select")}</option>
                    <option value="C">{t("monProfile.activityTypes.agriculture")}</option>
                    <option value="L">{t("monProfile.activityTypes.livestock")} </option>
                  </select>

                  {errorMessage.cropsOrLivestock && (
                    <div className="text-danger mt-1">
                      {errorMessage.cropsOrLivestock}
                    </div>
                  )}

                </div>

                {/* Activité FR */}
                <div className="mb-3">
                  <label className="form-label required-label">
                    {t("common.french")}
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="activityType"
                    value={data.activityType}
                    onChange={onInputchange}
                  />

                  {errorMessage.activityType && (
                    <div className="text-danger mt-1">
                      {errorMessage.activityType}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.arabic")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                    {t("common.arabic")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="activityTypeArab"
                    value={data.activityTypeArab}
                    onChange={onInputchange}
                    dir="rtl"
                  />

                  {errorMessage.activityTypeArab && (
                    <div className="text-danger mt-1">
                      {errorMessage.activityTypeArab}
                    </div>
                  )}

                </div>

                {/* Activité {t("common.english")} */}
                <div className="mb-3">

                  <label className="form-label required-label">
                   {t("common.english")}
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="activityTypeAng"
                    value={data.activityTypeAng}
                    onChange={onInputchange}
                  />

                  {errorMessage.activityTypeAng && (
                    <div className="text-danger mt-1">
                      {errorMessage.activityTypeAng}
                    </div>
                  )}

                </div>

              </div>

            </div>

            <div className="text-center mt-4">

              <button
                Type="submit"
                className="btn btn-outline-primary"
              >
                {t("button.save")}
              </button>

              <Link
                to="/ListActivitytype"
                className="btn btn-outline-success mx-2"
              >
                {t("button.close")}
              </Link>

            </div>

          </form>

        </div>

      </div>

    </div>
  );
}